import { render, staticRenderFns } from "./fieldInfo.vue?vue&type=template&id=2a6a3278&"
import script from "./fieldInfo.vue?vue&type=script&lang=js&"
export * from "./fieldInfo.vue?vue&type=script&lang=js&"
import style0 from "./fieldInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports